<template>
	<div>
		<c-dialog ref="dialog" :title="sku?'商品规格库':'商品库'" width="1100" @resolve="resolve">
			<m-search ref="search" @search="search">
				<m-search-item label="类型" style="width:180px;" v-if="userInfo.platform_user_id!=0 && userInfo.stationed_type == 2">
					<c-checkbox-group name="types" :options="productTypeData"></c-checkbox-group>
				</m-search-item>
				<m-search-item label="定制" style="width:180px;" v-if="systemConfig.product_custom == 'ON'">
					<c-checkbox-group name="customs" :options="iscustomData"></c-checkbox-group>
				</m-search-item>
				<m-search-item label="商品名称">
					<c-input name="product_name"> </c-input>
				</m-search-item>
				<m-search-item label="货号">
					<c-input name="product_itemnumber"></c-input>
				</m-search-item>
				<m-search-item label="状态">
					<c-checkbox-group name="state" :options="productStateCheck"></c-checkbox-group>
				</m-search-item>
			</m-search>
				
			<c-table ref="table" height="550">
				<c-table-column
					type="selector"
					:multiple="!!multiple"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="60"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 0" style="color:red">{{dict.productState[data.state]}}</span>
						<span v-if="data.state == 1" style="color:#999999">{{dict.productState[data.state]}}</span>
						<span v-if="data.state == 2" style="color:green">{{dict.productState[data.state]}}</span>
						<span v-if="data.state == 3" style="color:blue">{{dict.productState[data.state]}}</span>
						<span v-if="data.state == 4" style="color:red">{{dict.productState[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="商品信息"
					name="product_name"
					width="300"
				>
					<template v-slot="{data}">
						<product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
						<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
					</template>
				</c-table-column>
				
				<c-table-column
					label="类型"
					width="80"
					name="platfrom_product_id"
					v-if="userInfo.platform_user_id!=0 && userInfo.stationed_type == 2"
				>
					<template #default="{data}">
						<span v-if="data.platfrom_product_id" style="color:blue">分销</span>
						<span v-else>自建</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="定制"
					width="60"
					name="is_custom"
					v-if="systemConfig.product_custom == 'ON'"
				>
					<template #default="{data}">
						<span v-if="data.is_custom == 1" style="color:blue">支持</span>
						<span v-else style="color:#999">不支持</span>
					</template>
				</c-table-column>
				
				<c-table-column
					v-if="sku"
					label="规格名称"
					name="product_sku_spec"
					width="160"
				></c-table-column>

				<c-table-column
					v-if="!sku"
					label="所属类目"
					name="product_type_full_name"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="售价(元)"
					name="product_price"
					width="100"
				>
					<template v-slot="{data}">
						￥{{data.product_price}}
					</template>
				</c-table-column>

				<c-table-column
				  v-if="sku"
				  label="商品库存"
				  name="stock_count"
				  width="75"
				></c-table-column>
			  
			</c-table>
		</c-dialog>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import productInfo from '@/components/public/product_info.vue'
	
	export default {
		components: {
			productInfo
		},
		
		props: {
			sku: Boolean,
			
			multiple: Boolean
		},
		
		computed: {
			...mapState(['dict']),
			...mapState(['systemConfig']),
			...mapState(['userInfo'])
		},
    data() {
		return {
			productStateCheck: [{
					name: '草稿',
					value: 0
				}, {
					name: '上架',
					value: 2
				}, {
					name: '下架',
					value: 1
				// }, {
				// 	name: '待审核',
				// 	value: 3
				// }, {
				// 	name: '已驳回',
				// 	value: 4
				}],
				productTypeData: [{
					name: '自建',
					value: '1'
				}, {
					name: '分销',
					value: '2',
				}],
				iscustomData: [{
					name: '支持',
					value: '1'
				}, {
					name: '不支持',
					value: '0'
				}]
		}
    },
		methods: {
			search(data) {
				if (!data.state || data.state.length <= 0){
					data.state = [1,2];
				}
				this.$refs.table.load({
					url: this.sku ? '/product/sku/list' : '/product/list',
					data
				});
			},
			
			open(sta_type) {
				this.$refs.search.clear();
				this.$refs.search.search();
				this.$refs.dialog.open();
			},
			
			resolve(stop) {
				var data = this.$refs.table.getRow('selected');
				if (!data.length) {
					stop();
					this.$message({
						text: '请选择商品'
					});
					return;
				}
				this.$emit('resolve', Array.from(data, item => item.data));
			},
			
		}
	}
</script>